<!-- This is a HTML code snippet for a header section with a title, description, and two buttons -->
<!-- The outermost div has classes for styling -->
 <div class="container-fluid">
    <app-page-header header="{{releaseTitle}}" description="{{releaseDescription}}"
    [showBreadcrumb]="false">
      <div header-buttons>
        <!-- The Refresh button, which calls the `refreshData` method when clicked -->
        <button class="mdc-button mdc-button--outlined ml-1 add-button-width button-black infoIconButton" mat-stroked-button
          (click)="refreshData()">
          <span class="mdc-button__label">
            Refresh
            <mat-icon mat-icon-button matSuffix matTooltip="Click to view the latest status of Releases in table below"
              aria-hidden="true" matTooltipClass="ey-custom-tooltip"
              matTooltipPosition="below" style="margin-bottom: -3px;  align-items: center; vertical-align: middle; font-size: 18px;">
              info
            </mat-icon>
          </span>
        </button>
        <!-- The Add New Release button, which calls the `addNewRelease` method when clicked -->
        @if(this.userAuthService.checkPermission('MANAGE.RELEASE.ADD'))
        {
           <button class="mdc-button mdc-button--outlined ml-1 add-button-width button-black infoIconButton" mat-stroked-button
          (click)="addNewRelease()">
          <span class="mdc-button__label">
            <i class="material-icons mdc-button__icon" aria-hidden="true">add</i>
            Add New Release
            <mat-icon mat-icon-button matSuffix matTooltip="Click on the button to add a new release"
              aria-hidden="true" matTooltipClass="ey-custom-tooltip"
              matTooltipPosition="below" style="margin-bottom: -3px;  align-items: center; vertical-align: middle; font-size: 18px;">
              info
            </mat-icon>
          </span>
        </button>
        }
      </div>
    </app-page-header>
  <div>
    <!-- This is an Angular component for the ag-Grid library, a feature-rich datagrid designed for the major JavaScript Frameworks -->
    <!-- The ag-Grid Angular component is being used with various inputs and outputs -->
    <!-- Inputs: -->
    <!-- [style] - Inline styles for the grid -->
    <!-- [rowHeight] - The height of each row in the grid -->
    <!-- [sideBar] - Configuration for the grid's sidebar -->
    <!-- [columnDefs] - Definitions for the grid's columns -->
    <!-- [defaultColDef] - Default properties for the grid's columns -->
    <!-- [pagination] - Whether pagination is enabled -->
    <!-- [rowModelType] - The type of row model to use -->
    <!-- [serverSideStoreType] - The type of server-side data store to use -->
    <!-- [suppressContextMenu] - Whether to suppress the context menu -->
    <!-- [cacheBlockSize] - The number of rows to fetch in each block for the Infinite Row Model -->
    <!-- [maxBlocksInCache] - The maximum number of blocks to keep in the cache -->
    <!-- [blockLoadDebounceMillis] - The debounce time in milliseconds for the block loading in Infinite Row Model -->
    <!-- [paginationPageSize] - The number of rows per page for pagination -->
    <!-- [overlayNoRowsTemplate] - The template to show when there are no rows to render -->
    <!-- [headerHeight] - The height of the header row in pixels -->
    <!-- [frameworkComponents] - Angular components to use in the grid -->
    <!-- Outputs: -->
    <!-- (gridReady) - Event fired when the grid is ready -->
    <!-- (cellClicked) - Event fired when a cell is clicked -->
    <div class="release-min-height" id="releaseManagement">
      <ag-grid-angular [style]="styleChipDiv" class="ag-theme-material release-management-grid" (gridReady)="onGridReady($event)"
      [rowHeight]="rowHeight" [sideBar]="sideBar" [columnDefs]="columnDefs" id="triggerReleaseGrid"
      [defaultColDef]="defaultColDef" [rowModelType]="rowModelType" [infiniteInitialRowCount]="infiniteInitialRowCount"
      [serverSideStoreType]="agGridConfigurationService.serverSideStoreType" [suppressContextMenu]="true"
      [cacheBlockSize]="cacheBlockSize" [maxBlocksInCache]="maxBlocksInCache"
      [blockLoadDebounceMillis]="blockLoadDebounceMillis" suppressRowClickSelection="true" suppressMenu="true"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate" [headerHeight]="29" #contextMenu
      (cellClicked)="tableMenuClick($event, contextMenu, actionsList)" [gridOptions]="gridOptions"
      [frameworkComponents]="frameworkComponents">
    </ag-grid-angular>
    </div>

    <!-- This is an Angular template for a list of actions -->
    <!-- The `ng-template` element defines a template that isn't rendered immediately. It is referenced using the `#actionsList` template reference variable -->
    <!-- Inside the template, a list (`ul`) of actions (`li`) is created. Each action has a click event bound to the `updateStatusAction` method with a different argument -->
    <!-- Some actions are conditionally rendered using the `*ngIf` directive. They only appear if the `selectedRow` object has certain properties set to 'Success' -->
    <ng-template #actionsList let-action>
      <div *ngIf="isMenuShow">
        <ul class="mdc-list demo-list mdc-elevation--z2 b-white margin-right-20">
        @if(this.userAuthService.checkPermission('MANAGE.BRANCH.ADD'))
          {
          <li *ngIf="action.RepoCreationStatus && action.RepoCreationStatus?.toLowerCase() !== 'success'"
            class="mdc-button mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            (click)="updateStatusAction('CREATERELEASEBRANCH', action)" (keydown)="noop()"> <!-- //NOSONAR -->
            <!-- (click)="createBranch(action)"> //NOSONAR -->
            <span class="mdc-fab__icon material-icons-outlined">create</span>
            &nbsp;&nbsp;
            <span *ngIf="action?.IsBranchCreationUpdateCall">Update Release
              branch</span>
            <span *ngIf="!action?.IsBranchCreationUpdateCall">Create Release
              branch</span>
          </li>
        }
          @if(this.userAuthService.checkPermission('MANAGE.MANIFEST.TRIGGER'))
          {
          <li
            *ngIf="action.RepoCreationStatus &&  action.RepoCreationStatus?.toLowerCase() === 'success' && action.PipelineCreationStatus &&  action.PipelineCreationStatus?.toLowerCase() !== 'success'"
            class="mdc-button mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            (click)="updateStatusAction('CREATERELEASEPIPELINE', action)" (keydown)="noop()"> <!-- //NOSONAR -->
            <span class="mdc-fab__icon material-icons-outlined">new_releases</span>
            &nbsp;&nbsp;
            <span
              *ngIf="action?.PipelineCreationStatus && action?.PipelineCreationStatus.toLowerCase() !== 'not started'">Update
              Release Manifest</span>
            <span
              *ngIf="!action?.PipelineCreationStatus || action?.PipelineCreationStatus.toLowerCase() === 'not started'">Create
              Release Manifest</span>
          </li>
          }
          @if(this.userAuthService.checkPermission('MANAGE.RELEASE.ADD'))
          {
            <li [class.disabled]="hotfixDisabledStatus[action.Id]"
                *ngIf="action.ReleaseType?.toLowerCase() === 'release' && action.RepoCreationStatus && action.RepoCreationStatus?.toLowerCase() === 'success' && action.PipelineCreationStatus && action.PipelineCreationStatus?.toLowerCase() === 'success'"
                class="mdc-button mdc-list-item mdc-ripple-upgraded context-menu-heigth" 
                (click)="triggerHotfixDeployment(action)"
                (keydown)="noop()">
            
              <span class="mdc-fab__icon material-icons-outlined">create</span>
              &nbsp;&nbsp;Create Hotfix/Patch release&nbsp;&nbsp;
            
              <!-- Show info icon only when disabled and use API response message -->
              <mat-icon *ngIf="hotfixDisabledStatus[action.Id]"
              style="color: #000; font-size: 18px; height:20px; pointer-events: auto; cursor: pointer; margin-left: auto;" 
              matSuffix
              [matTooltip]="getHotfixTooltipMessage(action.Id)" 
              matTooltipPosition="above" 
              matTooltipClass="ey-custom-tooltip"
              aria-hidden="true"
              (click)="$event.stopPropagation()" (keydown)="noop()">info</mat-icon> <!-- //NOSONAR -->
                </li>
          }
          <!-- Rollback option -->
          <li class="mdc-button mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            *ngIf="action.RepoCreationStatus && action.RepoCreationStatus?.toLowerCase() === 'success' && action.PipelineCreationStatus && action.PipelineCreationStatus?.toLowerCase() === 'success' && action.DeploymentStatus && (action.DeploymentStatus?.toLowerCase() === 'success' || action.DeploymentStatus?.toLowerCase() === 'partial success')"
            (click)="triggerRollbackMigration(action)" (keydown)="noop()"> <!-- //NOSONAR -->
            <span class="mdc-fab__icon material-icons-outlined">autorenew
            </span>
            &nbsp;&nbsp;Rollback Database
          </li>
          @if(this.userAuthService.checkPermission('MANAGE.RELEASE.DEPLOYMENT.PIPELINE.TRIGGER'))
          {
          <li class="mdc-button mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            *ngIf="action.RepoCreationStatus && action.RepoCreationStatus?.toLowerCase() === 'success' && action.PipelineCreationStatus && action.PipelineCreationStatus?.toLowerCase() === 'success' && action.DeploymentStatus && action.DeploymentStatus?.toLowerCase() !== 'in progress'"
            (click)="triggerReleaseDeployment(action)" (keydown)="noop()"> <!-- //NOSONAR -->
            <span class="mdc-fab__icon material-icons-outlined">send</span>
            &nbsp;&nbsp;Trigger Release Deployment
          </li>
          }
          @if(this.userAuthService.checkPermission('MANAGE.RELEASE.DEPLOYMENT.STATUS.VIEW'))
          {
          <li class="mdc-button mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            *ngIf="action.RepoCreationStatus && action.RepoCreationStatus?.toLowerCase() === 'success' && action.PipelineCreationStatus && action.PipelineCreationStatus?.toLowerCase() === 'success' && action.DeploymentStatus && action.DeploymentStatus?.toLowerCase() === 'success'"
            (click)="updateStatusAction('VIEWSTATUS', action)" (keydown)="noop()"> <!-- //NOSONAR -->
            <span class="mdc-fab__icon material-icons-outlined">view_carousel</span>
            &nbsp;&nbsp;View Deployment Status
          </li>
          }
          <!-- <li class="mdc-button mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            *ngIf="action.RepoCreationStatus && action.RepoCreationStatus?.toLowerCase() === 'success' && action.PipelineCreationStatus && action.PipelineCreationStatus?.toLowerCase() === 'success' && action.DeploymentStatus && action.DeploymentStatus?.toLowerCase() === 'success'"
            (click)="updateStatusAction('SYNCDB', action)" (keydown)="noop()"> 
            <span class="mdc-fab__icon material-icons-outlined">sync</span>
            &nbsp;&nbsp;Sync Staging DB
          </li> -->
        </ul>
      </div>
    </ng-template>
  </div>
</div>